import { forwardRef } from 'react';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M21.6 2.66667V4.3L1.932 8.12667C0.816001 8.34833 0 9.305 0 10.4133V13.5867C0 14.695 0.804001 15.6517 1.932 15.8733L2.4 15.9667V18.6733C2.4 19.7817 3.204 20.7383 4.32 20.96L9.12 21.9167C10.608 22.22 12 21.1117 12 19.63V17.8333L21.6 19.7V21.3333C21.6 21.975 22.14 22.5 22.8 22.5C23.46 22.5 24 21.975 24 21.3333V2.66667C24 2.025 23.46 1.5 22.8 1.5C22.14 1.5 21.6 2.025 21.6 2.66667ZM9.6 18.2533C9.6 18.9883 8.904 19.5483 8.16 19.3967L5.76 18.9183C5.208 18.8017 4.8 18.335 4.8 17.775V16.4333L9.6 17.3667V18.2533ZM21.6 17.3667L3.36 13.82C2.796 13.715 2.4 13.2367 2.4 12.6767V11.3233C2.4 10.7633 2.808 10.285 3.36 10.18L21.6 6.63334V17.3667Z' />
        </SvgIcon>
    );
});
